import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { AdminLayoutComponent } from 'app/layouts/admin/admin-layout.component';
import { AbonoComponent } from './pages/abono/abono.component';
import { AbonosComponent } from './pages/abonos/abonos.component'


const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    data: {
      breadcrumb: 'Recaudaciones'
    },
    children: [
      {
        path: 'abonos',
        canActivate: [AuthGuard],
        component: AbonosComponent,
        data: {
          breadcrumb: 'Recaudaciones'
        }
      },
      {
        path: 'abonos/nuevo',
        canActivate: [AuthGuard],
        component: AbonoComponent,
        data: {
          breadcrumb: 'Registrar recaudación'
        }
      },
      {
        path: 'abonos/:id',
        canActivate: [AuthGuard],
        component: AbonoComponent,
        data: {
          breadcrumb: 'Editar recaudación'
        }
      },
    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AbonosRoutingModule { }

